import React from "react";
import { Workflow, BCMSDate } from "bcms-react";

import ChatItem from "./classes/ChatItem";
import LoginPage from "components/pages/LoginPage";
import ChatPage from "components/pages/ChatPage";

// Steps of the workflow
const steps = [ LoginPage, ChatPage ];
// The constructor to use when using the 'force-workflow-state' event
const constructor = record => {
    const messages = record.messages.map(item => new ChatItem(item), []);
    return { ...record, "messages" : messages };
};

/**
 * @function ChatWorkflow
 * @returns {React.Component}
 * @description Returns the chat workflow main component
 * @exported true
 */
export default function ChatWorkflow(props) {
    const value = getDefaultData();
    return <Workflow value={ value } steps={ steps } constructor={ constructor }/>
}

/**
 * @function getWorkflowSteps
 * @returns {ARRAY}
 * @description Returns the steps of the workflow
 * @exported true
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefaultChat
 * @returns {OBJECT}
 * @description Returns the default state data for the workflow
 * @exported true
 */
export const getDefaultData = () => {
    return {
        "sessionHasEnded" : false,
        "messages" : [],
        "showInitialMessage" : true
    };
}